import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Configure axios to send cookies
axios.defaults.withCredentials = true;

export const api = {
  // ─── Authentication ───
  register: (email, password, name) =>
    axios.post(`${API}/auth/register`, { email, password, name }),
  
  login: (email, password) =>
    axios.post(`${API}/auth/login`, { email, password }),
  
  exchangeSession: (sessionId) =>
    axios.post(`${API}/auth/session`, { session_id: sessionId }),
  
  getMe: () => axios.get(`${API}/auth/me`),
  
  logout: () => axios.post(`${API}/auth/logout`),

  // Chat / Conversation
  sendConversation: (message, sessionId, language) =>
    axios.post(`${API}/chat/conversation`, { message, session_id: sessionId, language }),

  // Short Advice
  getAdvice: (message, language) =>
    axios.post(`${API}/chat/advice`, { message, language }),

  // TTS
  generateTTS: (text, language) =>
    axios.post(`${API}/tts/generate`, { text, language }),

  // Daily Advice
  getDailySettings: () => axios.get(`${API}/daily-advice/settings`),
  updateDailySettings: (settings) => axios.post(`${API}/daily-advice/settings`, settings),
  getDailyMessage: (language) => axios.get(`${API}/daily-advice/message`, { params: { language } }),

  // Photo Generation
  generatePhoto: (formData) =>
    axios.post(`${API}/photo/generate`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    }),

  // Chat History
  getChatHistory: (sessionId) => axios.get(`${API}/chat/history/${sessionId}`),

  // Languages
  getLanguages: () => axios.get(`${API}/languages`),

  // Usage
  getUsage: () => axios.get(`${API}/usage`),

  // HeyGen Talking Avatar
  generateHeyGenVideo: (text, language) =>
    axios.post(`${API}/heygen/generate-video`, { text, language }),
  getHeyGenVideoStatus: (videoId) =>
    axios.get(`${API}/heygen/video-status/${videoId}`),

  // Push Notifications
  subscribePush: (subscription) =>
    axios.post(`${API}/push/subscribe`, subscription),
  unsubscribePush: (subscription) =>
    axios.post(`${API}/push/unsubscribe`, subscription),
  testPush: () =>
    axios.post(`${API}/push/test`),
  getVapidPublicKey: () =>
    axios.get(`${API}/push/vapid-public-key`),
};
